// extracted by mini-css-extract-plugin
export var bodySections = "_4g-8";
export var gray = "_4g-7";
export var green = "_4g-4";
export var iconContainer = "_4g-9";
export var iconWidgetContainer = "_4g-1";
export var phoneIcon = "_4g-2";
export var red = "_4g-5";
export var statusDot = "_4g-3";
export var widgetContainer = "_4g-0";
export var yellow = "_4g-6";